import tools from '../tools/tools.js';

function Grids(){
	document.querySelectorAll(".glowz-grid").forEach(function(grid){
		const columns = grid.querySelector(':scope > .glowz-grid-columns');
		const gridItems = columns.querySelectorAll(':scope > .glowz-grid-item, :scope > .wp-block-glowz-ext-glowz-section, :scope .glowz-grid > .glowz-grid-columns > .glowz-grid-item, :scope .glowz-grid > .glowz-grid-columns > .wp-block-glowz-ext-glowz-section');
		const btns = grid.querySelectorAll(':scope > .glowz-grid-filters .glowz-filter');
		const all = grid.querySelector(':scope > .glowz-grid-filters .glowz-filter-all');
		if(all){
			all.classList.add('glowz-grid-filter-active');
		}
		let currentGroup = null;
		btns.forEach(function(btn){btn.addEventListener('click', function(e){
			e.preventDefault();
			var isActive = this.classList.contains('glowz-grid-filter-active');
			var	group = isActive ? null : this.getAttribute('data-glowz-filter');
			if(currentGroup !== group){
				currentGroup = group;
				btns.forEach(function(btn){btn.classList.remove('glowz-grid-filter-active')});
				if(!isActive){
					this.classList.add('glowz-grid-filter-active');
				}else{
					all.classList.add('glowz-grid-filter-active');
				}
				gridItems.forEach(function(it){
					const inGrp = function(){
						const f = it.getAttribute('data-glowz-filters');
						return f && f.indexOf(group)!=-1;
					}
					const t = 0.35
					const del = t*1000
					const addDel = 100
					it.style.transition = 'opacity '+t+'s'
					it.style.opacity = '0'
					setTimeout(()=>{
						if( group === null || group === "" || inGrp() ){
							// Show
							it.style.removeProperty('display');
							setTimeout(()=>{
								it.style.opacity = '1'
								setTimeout(()=>{
									it.style.removeProperty('opacity');
									it.style.removeProperty('transition');
									it.style.removeProperty('transform');
								}, del)
							},40)
						}else{
							// Hide
							it.style.display = 'none'

						}
					}, del)
				});
			}
			return false;
		})});
	})
	document.querySelectorAll(".glowz-grid-item.glowz-set-image-h.glowz-image-h-preload-no").forEach(function(hov){
		const dataImgH = hov.getAttribute('data-glowz-img-h');
		if(dataImgH){
			const imhH = JSON.parse(dataImgH);
			if(imhH && imhH.src){
				const bars = document.createElement('ul');
				bars.classList.add('glowz-bars');
				bars.innerHTML =`
					<li></li>
					<li></li>
					<li></li>
				`;
				const imgUrl = tools.isPhoton() ? tools.photonUrl(imhH.src) : imhH.src;
				//const imgUrl = tools.isPhoton() ? tools.photonUrl(imhH.src) + '&ttt='+Date.now() : imhH.src + '?ttt='+Date.now();
				const img = document.createElement("img");
				img.alr = imhH.alt;
				img.classList.add('glowz-grid-item-image-h');
				let isHover = false;
				let hoverInsert;
				let hoverRemove;
				const imgWrap = hov.querySelector('.glowz-image-wrapper');
				const mainImg = hov.querySelector('.glowz-grid-item-image');
				let mainImgParent = null;
				if(mainImg){
					mainImgParent = mainImg.parentElement;
					mainImgParent.appendChild(bars);
				}
				if(imgWrap){
					hoverInsert = ()=> imgWrap.appendChild(img);
					hoverRemove = ()=> imgWrap.removeChild(img);
				}else{
					const hovContent = hov.querySelector('.glowz-grid-item-content');
					if(hovContent){
						const imgContainer = hovContent.parentElement;
						hoverInsert = ()=> imgContainer.insertBefore(img, hovContent);
						hoverRemove = ()=> imgContainer.removeChild(img);
					}else if(mainImgParent){
						hoverInsert = ()=> mainImgParent.appendChild(img);
						hoverRemove = ()=> mainImgParent.removeChild(img);
					}
				}
				img.onload = ()=>{
					setTimeout(()=>{
						bars.classList.remove('glowz-show');
					}, 1000);
				}
				hov.addEventListener("pointerenter", function( event ) {
					if(!isHover){
						isHover = true;
						img.setAttribute('src', imgUrl);
						hoverInsert();
						bars.classList.add('glowz-show');
						setTimeout(()=>{
							if(isHover){
								img.classList.add('glowz-show');
							}
						});
					}
				}, tools.passiveListener);
				hov.addEventListener("pointerleave", function( event ) {
					if(isHover){
						isHover = false;
						img.classList.remove('glowz-show');
						bars.classList.remove('glowz-show');
						img.setAttribute('src', '');
						hoverRemove();
					}
				}, tools.passiveListener);
			}
		}
	});
};
export default Grids;
